module.exports = __webpack_public_path__ + "img/plane_100.4de54bd5.jpg";